/*
 * <collection-tabs> — tab switching for the "Collection tabs" section.
 *
 * Every panel is rendered server side, so with JavaScript disabled all panels
 * stay visible and stacked. This only takes over showing one at a time.
 */
;(function () {
  if (customElements.get("collection-tabs")) return

  class CollectionTabs extends HTMLElement {
    constructor() {
      super()
      this.onBlockSelect = this.onBlockSelect.bind(this)
    }

    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'))
      if (!this.tabs.length) return

      this.addEventListener("click", (event) => {
        const tab = event.target.closest('[role="tab"]')
        if (tab) {
          this.select(tab)
          return
        }

        const pageLink = event.target.closest(".paginate a")
        if (pageLink) {
          event.preventDefault()
          this.loadPage(pageLink)
        }
      })

      this.addEventListener("keydown", (event) => this.onKeydown(event))

      document.addEventListener("shopify:block:select", this.onBlockSelect)
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:block:select", this.onBlockSelect)
    }

    panelFor(tab) {
      return this.querySelector("#" + tab.getAttribute("aria-controls"))
    }

    select(tab, focusTab) {
      if (!tab || tab.getAttribute("aria-selected") === "true") return

      this.tabs.forEach((item) => {
        const isSelected = item === tab
        const panel = this.panelFor(item)

        item.setAttribute("aria-selected", isSelected)
        item.setAttribute("tabindex", isSelected ? "0" : "-1")
        if (panel) panel.hidden = !isSelected
      })

      if (focusTab) tab.focus()
    }

    loadPage(link) {
      const panel = link.closest('[role="tabpanel"]')
      const grid = panel && panel.querySelector("[data-panel-grid]")
      if (!grid) return

      const url = `${window.location.pathname}?section_id=${this.dataset.sectionId}&${link.search.replace(/^\?/, "")}`

      panel.setAttribute("aria-busy", "true")

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const incoming = new DOMParser().parseFromString(html, "text/html").getElementById(panel.id)
          const fresh = incoming && incoming.querySelector("[data-panel-grid]")
          if (!fresh) throw new Error("panel missing from response")

          grid.innerHTML = fresh.innerHTML
          panel.removeAttribute("aria-busy")
          this.scrollIntoView({ behavior: "smooth", block: "start" })
        })
        .catch(() => {
          // fall back to a normal page load
          window.location.href = link.href
        })
    }

    onKeydown(event) {
      const current = this.tabs.indexOf(event.target)
      if (current === -1) return

      let next

      switch (event.key) {
        case "ArrowRight":
          next = (current + 1) % this.tabs.length
          break
        case "ArrowLeft":
          next = (current - 1 + this.tabs.length) % this.tabs.length
          break
        case "Home":
          next = 0
          break
        case "End":
          next = this.tabs.length - 1
          break
        default:
          return
      }

      event.preventDefault()
      this.select(this.tabs[next], true)
    }

    onBlockSelect(event) {
      if (!this.contains(event.target)) return
      this.select(this.querySelector('[aria-controls="panel-' + event.detail.blockId + '"]'))
    }
  }

  customElements.define("collection-tabs", CollectionTabs)
})()
